import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {HttpLink} from 'apollo-angular/http';

import { AppRoutingModule } from './app-routing.module';
import {HttpClientModule} from '@angular/common/http';


//COMPONENTES
import { AppComponent } from './app.component';
import { TablaClientesComponent } from './components/portal-inproeco/cliente/tabla-clientes/tabla-clientes.component';
import { TablaCentrosComponent } from './components/portal-inproeco/centro/tabla-centros/tabla-centros.component';
import { TablaInstalacionesComponent } from './components/portal-inproeco/instalacion/tabla-instalaciones/tabla-instalaciones.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { TablaContratistasComponent } from './components/portal-inproeco/contratista/tabla-contratistas/tabla-contratistas.component';
import { TablaGestoresComponent } from './components/portal-inproeco/gestor/tabla-gestores/tabla-gestores.component';
import { TablaTransportistasComponent } from './components/portal-inproeco/transportista/tabla-transportistas/tabla-transportistas.component';

//SERVICIOS
import { ClienteService } from './services/cliente.service';
import { CentroService } from './services/centro.service';
import { InstalacionService } from './services/instalacion.service';
import { ContratistaService } from './services/contratista.service';
import { GestorService } from './services/gestor.service';
import { TransportistaService } from './services/transportista.service';
import { ConfirmacionService } from './services/confirmacion.service';
import { PaginatorService } from './services/paginator.service';
import { DocumentoService } from './services/documento.service';
import { UsuariosService } from './services/usuarios.service';

//APOLLO
import {APOLLO_OPTIONS} from 'apollo-angular';
import {InMemoryCache, ApolloLink } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
import { onError } from 'apollo-link-error';

import {MatBadgeModule} from '@angular/material/badge';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatListModule } from '@angular/material/list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { MenuSidebarComponent } from './components/sidebar/menu-sidebar/menu-sidebar.component';
import { TabsComponent } from './components/tabs/tabs.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { NuevaEntidadComponent } from './components/genericos/botones/nueva-entidad/nueva-entidad.component';
import { DescargarComponent } from './components/genericos/botones/descargar/descargar.component';
import { InputTablaComponent } from './components/genericos/inputs/input/input-tabla.component';
import { NavBarComponent } from './components/nav-bar/nav-bar.component';
import { MainComponent } from './components/main/main.component';
import { ConfirmacionComponent } from './components/confirmacion/confirmacion.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { LogoComponent } from './components/sidebar/logo/logo.component';
import { UserComponent } from './components/sidebar/user/user.component';
import { TituloHeaderComponent } from './components/titulo-header/titulo-header.component';
import { MainPortalClienteComponent } from './components/portal-cliente/main-portal-cliente/main-portal-cliente.component';
import { PerfilClienteComponent } from './components/portal-cliente/perfil/perfil-cliente/perfil-cliente.component';
import { MainPortalContratistaComponent } from './components/portal-contratista/main-portal-contratista/main-portal-contratista.component';
import { PerfilContratistaComponent } from './components/portal-contratista/perfil/perfil-contratista/perfil-contratista.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSelectModule  } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MAT_DATE_LOCALE} from '@angular/material/core';
import { LoginComponent } from './components/login/login.component';
import { SidebarinproecoComponent } from './components/portal-inproeco/sidebar/sidebarinproeco/sidebarinproeco.component';
import { GeneralPortalInproecoComponent } from './components/portal-inproeco/general-portal-inproeco/general-portal-inproeco.component';
import { TablaUsuariosInproecoComponent } from './components/portal-inproeco/usuarios/tabla-usuarios-inproeco/tabla-usuarios-inproeco.component';
import { InicioEntidadesComponent } from './components/inicio-entidades/inicio-entidades.component';
import { HomeComponent } from './components/home/home.component';
import { MyDoughnutChartComponent } from './my-doughnut-chart/my-doughnut-chart.component';
import { ChartsModule } from 'ng2-charts';
import { DetalleCentroComponent } from './components/portal-inproeco/centro/tabla-centros/detalle-centro/detalle-centro.component';
import { NuevoGestorComponent } from './components/portal-inproeco/gestor/formularios/nuevo-gestor/nuevo-gestor.component';
import { MatStepperModule} from '@angular/material/stepper';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AltaXtensaBasicaFormComponent } from './components/alta-xtensa-basica-form/alta-xtensa-basica-form.component';
import { SidebarClienteComponent } from './components/portal-cliente/sidebar-cliente/sidebar-cliente.component';
import { ToolbarClienteComponent } from './components/portal-cliente/toolbar-cliente/toolbar-cliente.component';
import { NavBarClienteComponent } from './components/portal-cliente/nav-bar-cliente/nav-bar-cliente.component';
import { GeneralPortalClienteComponent } from './components/portal-cliente/general-portal-cliente/general-portal-cliente.component';
import { MenuClienteComponent } from './components/portal-cliente/sidebar-cliente/menu-cliente/menu-cliente.component';
import { TablaContratistaClienteComponent } from './components/portal-cliente/contratista/tabla-contratista-cliente/tabla-contratista-cliente.component';
import { InicioEntidadesClienteComponent } from './components/portal-cliente/inicio/inicio-entidades-cliente/inicio-entidades-cliente.component';
import { TablaCentrosClienteComponent } from './components/portal-cliente/centros/tabla-centros-cliente/tabla-centros-cliente.component';
import { TablaInstalacionesClienteComponent } from './components/portal-cliente/instalaciones/tabla-instalaciones-cliente/tabla-instalaciones-cliente.component';
import { TablaGestoresClienteComponent } from './components/portal-cliente/gestores/tabla-gestores-cliente/tabla-gestores-cliente.component';
import { TablaTransportistaClienteComponent } from './components/portal-cliente/transportistas/tabla-transportista-cliente/tabla-transportista-cliente.component';
import { TituloHeaderClienteComponent } from './components/portal-cliente/titulo-header-cliente/titulo-header-cliente.component';
import { GeneralPortalContratistaComponent } from './components/portal-contratista/general-portal-contratista/general-portal-contratista.component';
import { TablaCentrosContratistaComponent } from './components/portal-contratista/centro/tabla-centros-contratista/tabla-centros-contratista.component';
import { TablaGestoresContratistaComponent } from './components/portal-contratista/gestor/tabla-gestores-contratista/tabla-gestores-contratista.component';
import { TablaTransportistasContratistaComponent } from './components/portal-contratista/transportista/tabla-transportistas-contratista/tabla-transportistas-contratista.component';
import { TablaClientesContratistaComponent } from './components/portal-contratista/cliente/tabla-clientes-contratista/tabla-clientes-contratista.component';
import { TablaInstalacionesContratistaComponent } from './components/portal-contratista/instalacion/tabla-instalaciones-contratista/tabla-instalaciones-contratista.component';
import { TablaUsuariosContratistaComponent } from './components/portal-contratista/usuario/tabla-usuarios-contratista/tabla-usuarios-contratista.component';
import { SidebarContratistaComponent } from './components/sidebar-contratista/sidebar-contratista.component';
import { MenuSidebarContratistaComponent } from './components/sidebar-contratista/menu-sidebar-contratista/menu-sidebar-contratista.component';
import { InicioEntidadContratistaComponent } from './components/portal-contratista/inicio-entidad-contratista/inicio-entidad-contratista.component';
import { TituloHeaderContratistaComponent } from './components/titulo-header-contratista/titulo-header-contratista.component';
import { NavBarContratistaComponent } from './components/nav-bar-contratista/nav-bar-contratista.component';
import { ToolbarContratistaComponent } from './components/toolbar-contratista/toolbar-contratista.component';
import { NuevoClienteComponent } from './components/portal-inproeco/cliente/formularios/nuevo-cliente/nuevo-cliente.component';
import { NuevoContratistaComponent } from './components/portal-inproeco/contratista/formularios/nuevo-contratista/nuevo-contratista.component';
import { NuevaInstalacionComponent } from './components/portal-inproeco/instalacion/formularios/nueva-instalacion/nueva-instalacion.component';
import { NuevoTransportistaComponent } from './components/portal-inproeco/transportista/formularios/nuevo-transportista/nuevo-transportista.component';
import { BotonImprimirComponent } from './components/genericos/botones/boton-imprimir/boton-imprimir.component';
import { XtensaAmpliadaComponent } from './components/xtensa-ampliada/xtensa-ampliada.component';
import { DetalleContratistaComponent } from './components/portal-inproeco/contratista/detalle-contratista/detalle-contratista.component';
import { NuevaInstalacionClienteComponent } from './components/portal-cliente/instalaciones/formularios/nueva-instalacion-cliente/nueva-instalacion-cliente.component';
import { NuevoGestorContratistaComponent } from './components/portal-contratista/gestor/formularios/nuevo-gestor-contratista/nuevo-gestor-contratista.component';
import { NuevoTransportistaContratistaComponent } from './components/portal-contratista/transportista/formularios/nuevo-transportista-contratista/nuevo-transportista-contratista.component';
import { NuevoCentroContratistaComponent } from './components/portal-contratista/centro/formularios/nuevo-centro-contratista/nuevo-centro-contratista.component';
import { detalleContenidoComponent } from './components/portal-inproeco/cliente/detalle-cliente/detalle-cliente.component';
import { DetalleGestorComponent } from './components/portal-inproeco/gestor/detalle-gestor/detalle-gestor.component';
import { DetalleTransportistaComponent } from './components/portal-inproeco/transportista/detalle-transportista/detalle-transportista.component';
import { DetalleInstalacionComponent } from './components/portal-inproeco/instalacion/detalle-instalacion/detalle-instalacion.component';
import { ValidacionComponent } from './components/portal-inproeco/validacion/validacion.component';
import { TablaDocumentacionComponent } from './components/portal-inproeco/documentacion/tabla-documentacion/tabla-documentacion.component';
import { TablaValidacionesComponent } from './components/portal-inproeco/validacion/tabla-validaciones/tabla-validaciones.component';
import { DetallePerfilComponent } from './components/portal-cliente/detalle-perfil/detalle-perfil-cliente.component';
import { DetallePerfilContratistaComponent } from './components/portal-contratista/detalle-perfil-contratista/detalle-perfil-contratista.component';
import { InicioInproecoComponent } from './components/portal-inproeco/inicio-inproeco/inicio-inproeco.component';
import { UserClienteComponent } from './components/portal-cliente/sidebar-cliente/user-cliente/user-cliente.component';
import { UserContratistaComponent } from './components/sidebar-contratista/user-contratista/user-contratista.component';
import { TablaProximosCaducarComponent } from './components/portal-inproeco/documentacion/tabla-proximos-caducar/tabla-proximos-caducar.component';
import { MatFileUploadModule } from 'angular-material-fileupload';
import { NgxFileDropModule } from 'ngx-file-drop';
import { DocPropiaComponent } from './components/portal-contratista/doc-propia/doc-propia.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import { ComentariosComponent } from './components/portal-contratista/comentarios/comentarios.component';
import { DocumentosComponent } from './components/portal-contratista/gestor/formularios/documentos/documentos.component';
import { DocDetalleGestorComponent } from './components/portal-contratista/gestor/doc-detalle-gestor/doc-detalle-gestor.component';
import {LoginService} from './services/login.service';
import { DocDetalleTransportistaComponent } from './components/portal-contratista/transportista/doc-detalle-transportista/doc-detalle-transportista.component';
import { NuevoUsuarioComponent } from './components/portal-inproeco/usuarios/formularios/nuevo-usuario/nuevo-usuario.component';
import { DocumentosTransportistaComponent } from './components/portal-contratista/transportista/formularios/documentos-transportista/documentos-transportista.component';
import { DetalleUsuarioComponent } from './components/portal-inproeco/usuarios/detalle-usuario/detalle-usuario.component';
import { DocDetalleCentroComponent } from './components/portal-contratista/centro/doc-detalle-centro/doc-detalle-centro.component';
import { DocumentosCentroComponent } from './components/portal-contratista/centro/formularios/documentos-centro/documentos-centro.component';
import { ZonasGruposComponent } from './components/portal-cliente/zonas-grupos/zonas-grupos.component';
import { NuevaZonaComponent } from './components/portal-cliente/zonas-grupos/formularios/nueva-zona/nueva-zona.component';
import { NuevoGrupoComponent } from './components/portal-cliente/zonas-grupos/formularios/nuevo-grupo/nuevo-grupo.component';
import { InstalacionesAsignadasComponent } from './components/portal-cliente/zonas-grupos/formularios/instalaciones-asignadas/instalaciones-asignadas.component';
import { MatIconModule } from '@angular/material/icon';
import { InstalacionesAsignadasGruposComponent } from './components/portal-cliente/zonas-grupos/formularios/instalaciones-asignadas-grupos/instalaciones-asignadas-grupos.component';
import { NewPerfilClienteComponent } from './components/portal-cliente/new-perfil-cliente/new-perfil-cliente.component';
import { NewPerfilContratistaComponent } from './components/portal-contratista/new-perfil-contratista/new-perfil-contratista.component';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import { RecuperarPasswordComponent } from './components/recuperar-password/recuperar-password.component';
import { GestionComponent } from './components/portal-cliente/gestion/gestion.component';
import { FacturacionComponent } from './components/portal-inproeco/facturacion/facturacion.component';
import { AddClienteComponent } from './components/portal-contratista/centro/formularios/add-cliente/add-cliente.component';
import { LicenciasComponent } from './components/portal-contratista/licencias/licencias.component';
import { SolicitudCentrosComponent } from './components/portal-cliente/gestion/solicitud-centros/solicitud-centros.component';
import { AltaContratistaComponent } from './components/portal-cliente/gestion/alta-contratista/alta-contratista.component';
import { InvitacionesComponent } from './components/portal-contratista/invitaciones/invitaciones.component';
import { FacturacionContratistaComponent } from './components/portal-contratista/facturacion-contratista/facturacion-contratista.component';
import { PagoInvitacionComponent } from './components/portal-contratista/invitaciones/pago-invitacion/pago-invitacion.component';
import { RenovarLicenciaComponent } from './components/portal-contratista/licencias/renovar-licencia/renovar-licencia.component';
import { PopupLicenciaCaducadaComponent } from './components/portal-contratista/licencias/popup-licencia-caducada/popup-licencia-caducada.component';
import { PagoOkComponent } from './components/portal-contratista/pago-ok/pago-ok.component';
import { DocumentosAdicCentroComponent } from './components/portal-contratista/centro/formularios/documentos-adic-centro/documentos-adic-centro.component';
import { TablaAdicValidacionesComponent } from './components/portal-inproeco/validacion/tabla-adic-validaciones/tabla-adic-validaciones.component';
import { DocAdicDetalleCentroComponent } from './components/portal-contratista/centro/doc-adic-detalle-centro/doc-adic-detalle-centro.component';
import { ValidacionAdicionalComponent } from './components/portal-inproeco/validacion/validacion-adicional/validacion-adicional.component';

//AWS AMPLIFY
//import { AmplifyUIAngularModule } from '@aws-amplify/ui-angular';



const uri = 'https://backend-xtensa-core.app.inpronet.es/graphql';
/* const uri = 'https://xtensa-backup.app.inpronet.es/graphql';  */
//const uri = 'http://localhost:1337/graphql';

//UTILIZADO PARA LA CONEXIÓN CON AUTORIZACIÓN
export function createApollo(httpLink: HttpLink) {
  const basic = setContext((operation, context) => ({
    headers: {
      Accept: 'charset=utf-8'
    }
  }));

  const auth = setContext((operation, context) => {
    const token = JSON.parse(sessionStorage.getItem('token') || "null");

    if (token === null) {
      return {};
    } else {
      return {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };
    }
  });

  const link = ApolloLink.from([basic, auth, httpLink.create({ uri })]);
  const cache = new InMemoryCache( { 
    addTypename : false 
  } );
  return {
    link,
    cache
  }
}

const link = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.map(({ message, locations, path }) =>
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
      ),
    );

  if (networkError) console.log(`[Network error]: ${networkError}`);
});


@NgModule({
  declarations: [
    AppComponent,
    TablaClientesComponent,
    TablaCentrosComponent,
    TablaInstalacionesComponent,
    SidebarComponent,
    ToolbarComponent,
    MenuSidebarComponent,
    TabsComponent,
    TablaContratistasComponent,
    TablaGestoresComponent,
    TablaTransportistasComponent,
    NuevaEntidadComponent,
    DescargarComponent,
    InputTablaComponent,
    NavBarComponent,
    MainComponent,
    ConfirmacionComponent,
    PaginatorComponent,
    LogoComponent,
    UserComponent,
    TituloHeaderComponent,
    MainPortalClienteComponent,
    PerfilClienteComponent,
    MainPortalContratistaComponent,
    PerfilContratistaComponent,
    LoginComponent,
    SidebarinproecoComponent,
    GeneralPortalInproecoComponent,
    TablaUsuariosInproecoComponent,
    InicioEntidadesComponent,
    HomeComponent,
    MyDoughnutChartComponent,
    DetalleCentroComponent,
    NuevoGestorComponent,
    AltaXtensaBasicaFormComponent,
    SidebarClienteComponent,
    ToolbarClienteComponent,
    NavBarClienteComponent,
    GeneralPortalClienteComponent,
    MenuClienteComponent,
    TablaContratistaClienteComponent,
    InicioEntidadesClienteComponent,
    TablaCentrosClienteComponent,
    TablaInstalacionesClienteComponent,
    TablaGestoresClienteComponent,
    TablaTransportistaClienteComponent,
    TituloHeaderClienteComponent,
    GeneralPortalContratistaComponent,
    TablaCentrosContratistaComponent,
    TablaGestoresContratistaComponent,
    TablaTransportistasContratistaComponent,
    TablaClientesContratistaComponent,
    TablaInstalacionesContratistaComponent,
    TablaUsuariosContratistaComponent,
    SidebarContratistaComponent,
    MenuSidebarContratistaComponent,
    InicioEntidadContratistaComponent,
    TituloHeaderContratistaComponent,
    NavBarContratistaComponent,
    ToolbarContratistaComponent,
    NuevoClienteComponent,
    NuevoContratistaComponent,
    NuevaInstalacionComponent,
    NuevoTransportistaComponent,
    BotonImprimirComponent,
    XtensaAmpliadaComponent,
    DetalleContratistaComponent,
    NuevaInstalacionClienteComponent,
    NuevoGestorContratistaComponent,
    NuevoTransportistaContratistaComponent,
    NuevoCentroContratistaComponent,
    detalleContenidoComponent,
    DetalleGestorComponent,
    DetalleTransportistaComponent,
    DetalleInstalacionComponent,
    ValidacionComponent,
    TablaDocumentacionComponent,
    TablaValidacionesComponent,
    DetallePerfilComponent,
    DetallePerfilContratistaComponent,
    InicioInproecoComponent,
    UserContratistaComponent,
    UserClienteComponent,
    TablaProximosCaducarComponent,
    DocPropiaComponent,
    ComentariosComponent,
    DocumentosComponent,
    DocDetalleGestorComponent,
    DocDetalleTransportistaComponent,
    NuevoUsuarioComponent,
    DocumentosTransportistaComponent,
    DetalleUsuarioComponent,
    DocDetalleCentroComponent,
    DocumentosCentroComponent,
    ZonasGruposComponent,
    NuevaZonaComponent,
    NuevoGrupoComponent,
    InstalacionesAsignadasComponent,
    InstalacionesAsignadasGruposComponent,
    NewPerfilClienteComponent,
    NewPerfilContratistaComponent,
    RecuperarPasswordComponent,
    GestionComponent,
    FacturacionComponent,
    AddClienteComponent,
    LicenciasComponent,
    SolicitudCentrosComponent,
    AltaContratistaComponent,
    InvitacionesComponent,
    FacturacionContratistaComponent,
    PagoInvitacionComponent,
    RenovarLicenciaComponent,
    PopupLicenciaCaducadaComponent,
    PagoOkComponent,
    DocumentosAdicCentroComponent,
    TablaAdicValidacionesComponent,
    DocAdicDetalleCentroComponent,
    ValidacionAdicionalComponent,
 

  
 
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatTableModule,
    MatPaginatorModule,
    MatListModule,
    MatToolbarModule,
    MatSidenavModule,
    MatTabsModule,
    MatDialogModule,
    MatInputModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatSortModule,
    MatInputModule,
    MatCheckboxModule,
    ChartsModule,
    ReactiveFormsModule,
    FormsModule,
    MatStepperModule,
    MatSelectModule,
    MatFileUploadModule,
    NgxFileDropModule,
    MatTooltipModule,
    HttpClientModule,
    MatIconModule,
    MatSnackBarModule,
    MatBadgeModule,
    //AmplifyUIAngularModule
  ],
  entryComponents: [
    PerfilClienteComponent,
    GeneralPortalClienteComponent,
    InicioEntidadContratistaComponent,
    ToolbarClienteComponent,
    TituloHeaderClienteComponent,
  ],
  providers: [
    //CONEXIÓN CON AUTORIZACIÓN
    {
    provide: APOLLO_OPTIONS,
    useFactory: createApollo,
    deps: [HttpLink]
  },

  //CONEXION SIN AUTORIZACIÓN
  
    /* {provide: APOLLO_OPTIONS,
    useFactory: (httpLink: HttpLink) => {
      return {
        cache: new InMemoryCache({
          addTypename: false,
        }),
        link: httpLink.create({ uri }),
      };
    },
    deps: [HttpLink]}, */
    ClienteService,
    CentroService,
    InstalacionService,
    ContratistaService,
    GestorService,
    TransportistaService,
    PaginatorService,
    ConfirmacionService,
    DocumentoService,
    UsuariosService,
    //MENSAJE DE CONFIRMACIÓN
    {
      provide: MatDialogRef,
      useValue: {}
    },
    {
      provide: MatPaginatorIntl,
      useClass: PaginatorService
    },
    { provide: MAT_DATE_LOCALE,
      useValue: 'es-ES' 
    }
  ]
    ,
  bootstrap: [AppComponent]
})
export class AppModule { }
